export const SET_BENEFIT_CLASS_ID = 'qle-configuration/SET_BENEFIT_CLASS_ID';

export const SET_IS_EDIT_HR_EMAIL_ENABLED =
  'qle-configuration/SET_IS_EDIT_HR_EMAIL_ENABLED';
